import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import "./choose-us.css";

import ReactPlayer from "react-player";

const chooseImg1 = `
https://elpythonista.com/wp-content/uploads/2021/02/PyCharm_IDE.jpg
`;
const chooseImg2 = `
https://i.ytimg.com/vi/hK9-_s55CBY/maxresdefault.jpg
`;
const chooseImg3 = `
https://blog.jetbrains.com/wp-content/uploads/2020/12/blog_feat.png
`;
const chooseImg4 = `
https://resources.jetbrains.com/storage/products/pycharm/img/meta/pycharm_1280x800.png
`;

const VideoSub = () => {
    const [showVideo, setShowVideo] = useState(false);
    return (
        <section>
            <Container className="video-sub-container">
                <Row>

                    <Col lg="6" md="6">
                        <div className="choose__img">
                            {showVideo ? (
                                <ReactPlayer
                                    url="https://youtu.be/GNWDv_cE000"
                                    controls
                                    width="100%"
                                    height="350px"
                                />
                            ) : (
                                <img src={chooseImg3} alt="" className="w-100" />
                            )}

                            {!showVideo && (
                                <span className="play__icon">
                                    <i
                                        class="ri-play-circle-line"
                                        onClick={() => setShowVideo(!showVideo)}
                                    ></i>
                                </span>
                            )}
                        </div>
                    </Col>
                    <Col lg="6" md="6">
                        <div className="choose__img">
                            {showVideo ? (
                                <ReactPlayer
                                    url="https://youtu.be/x-X0Tlo3eJs"
                                    controls
                                    width="100%"
                                    height="350px"
                                />
                            ) : (
                                <img src={chooseImg4} alt="" className="w-100" />
                            )}

                            {!showVideo && (
                                <span className="play__icon">
                                    <i
                                        class="ri-play-circle-line"
                                        onClick={() => setShowVideo(!showVideo)}
                                    ></i>
                                </span>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default VideoSub;
